<template>
  <div class="pa-list">
    <position :position="item"></position>
    <div class="talent" v-if="item.talentMatchView" @click="goToDetail">
      <div class="top">
        <div class="img-wrap">
          <img v-if="item.talentMatchView.gender == 2" :src="item.talentMatchView.avatar | avatar('women')" v-img-error-user="2" alt="" />
          <img v-else :src="item.talentMatchView.avatar | avatar('men')" v-img-error-user="1" alt="" />
        </div>

        <div class="info">
          <p>
            <span class="title" v-if="item.talentMatchView.talentName">{{item.talentMatchView.talentName}}</span>
            <span class="salary" v-if="item.talentMatchView.annualSalary">{{item.talentMatchView.annualSalary}}万</span>
            <span class="time" v-if="item.talentMatchView.updateTimeDesc">{{item.talentMatchView.updateTimeDesc}}更新</span>
          </p>
          <div>
            <div class="separate-info-list">
              <span class="line" v-if="item.talentMatchView.gender">{{item.talentMatchView.gender | gender}}</span>
              <span class="line" v-if="item.talentMatchView.age">{{item.talentMatchView.age}}岁</span>
              <span class="line" v-if="item.talentMatchView.workYear">{{item.talentMatchView.workYear}}年</span>
              <span class="line" v-if="item.talentMatchView.talentCity">{{item.talentMatchView.talentCity}}</span>
            </div>
          </div>
          <div class="separate-info-list">
            <span class="line" v-if="item.talentMatchView.currentJobTitle">{{item.talentMatchView.currentJobTitle}}</span>
            <span class="line" v-if="item.talentMatchView.currentCompanyName">{{item.talentMatchView.currentCompanyName}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Position from '@/components/position/position'

export default {
  name: "paList",
  props: {
    item: {
      default(){
        return {
          
        }
      }
    }
  },
  data(){
  	return {
  	}
  },
  components: {
  	Position
  },
  methods: {
  	goToDetail(){
      let url = `/positions/detail/${this.item.positionId}`;
      this.$router.push(url);
    }
  },
  created() {}
};
</script>

<style scoped lang="scss">
  .pa-list{
    background-color: #fff;
  }
  .talent{
    padding: 15px 0;
    margin: -10px 15px 10px;
    border-top: 0.5px solid #E5E5E5;
    .top{
      display: flex;
      .time{
        font-size: 12px;
        color: #999;
        line-height: 20px;
        float: right;
      }
      .img-content{
        margin-right: 10px;
        border-radius: 4px;
        overflow: hidden;
      }
      .info{
        flex: 1;
        p{
          line-height: 20px;
          margin-bottom: 10px;
          font-size: 12px;
          color: #666666;
          .title{
            font-size: 16px;
          }
          .salary{
            font-size: 14px;
            color: #FF6E00;
            margin-left: 15px;
          }
          &:last-child{
            margin-bottom: 0;
          };
        }
      }
      .van-image{
        flex-shrink: 0;
        margin-right: 10px;
        border-radius: 4px;
        overflow: hidden;
      }
    }
  }
</style>